'use client';

import React, { useState } from 'react';
import WalimuridSidebar from './Sidebar';
import WalimuridHeader from './Header';

export default function WalimuridLayoutClient({
    children
}: {
    children: React.ReactNode
}) {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <div className="flex h-screen bg-background overflow-hidden relative">
            {/* Desktop Sidebar */}
            <WalimuridSidebar
                className="hidden lg:flex border-r sticky top-0"
                collapsed={isCollapsed}
                setCollapsed={setIsCollapsed}
            />

            {/* Mobile Sidebar Overlay */}
            {isMobileMenuOpen && (
                <div className="fixed inset-0 bg-black/20 z-50 lg:hidden font-sans animate-fade-in" onClick={() => setIsMobileMenuOpen(false)}>
                    <div className="absolute left-0 top-0 bottom-0 animate-slide-in-left" onClick={e => e.stopPropagation()}>
                        <WalimuridSidebar className="flex shadow-2xl h-full" onClose={() => setIsMobileMenuOpen(false)} />
                    </div>
                </div>
            )}

            <div className="flex-1 flex flex-col overflow-y-auto custom-scrollbar font-sans relative">
                <WalimuridHeader onMenuClick={() => setIsMobileMenuOpen(true)} />
                <main className="flex-1 p-6 md:p-10 max-w-7xl mx-auto w-full">
                    {children}
                </main>
            </div>
        </div>
    );
}
